import ApiClient from "./ApiClient";

export type SearchDateResponse = {
  id: string;
  fromDate: string;
  toDate: string;
};

export const getSearchDate = async (params: {
  targetDate: string;
}): Promise<SearchDateResponse> => {
  const companyCode = sessionStorage.getItem("loginUser.companyCode") || "";

  const query = {
    targetDate: params.targetDate
  };

  const response = await ApiClient.get(
    `/v2/sales/searchDate/${companyCode}`,
    {},
    query
  );
  return response.data;
};

export const getSearchDateRange = async (params: {
  fromDate: string;
  toDate: string;
}): Promise<SearchDateResponse> => {
  const companyCode = sessionStorage.getItem("loginUser.companyCode") || "";

  const query = {
    targetFromDate: params.fromDate,
    targetToDate: params.toDate
  };

  const response = await ApiClient.get(
    `/v2/sales/searchDate/range/${companyCode}`,
    {},
    query
  );
  return response.data;
};
